// src/store/thunks/user/fetchNotificationsThunk.ts

import type { Notifications } from '@/types/UserState';
import type { NotificationQueryParams } from '@/types/NotificationDTOs';
import { mapNotificationsPayloadDTOToNotifications } from '@/store/mappers/notifications';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const fetchNotificationsThunk = createAppAsyncThunk<
  Notifications,
  NotificationQueryParams | undefined
>(
  'user/fetchNotifications',
  async(params, { extra: { userService } }) => {
    const response = await userService.getNotifications(params);
    return mapNotificationsPayloadDTOToNotifications(response);
  }
);
